import type { LocationQuery } from 'vue-router'
import { shouldNavigateToProjectRequestFormAfterTemplateSave } from '~/shared/const'
import { permissions } from '~/shared/lib'

export function navigateAfterTemplateSave(
  router: ReturnType<typeof useRouter>,
  query: LocationQuery,
  projectId: string,
) {
  if (shouldNavigateToProjectRequestFormAfterTemplateSave(query)) {
    return router.replace({
      name: permissions.PROJECTS.REQUESTS.EDIT.PERMISSION,
      params: { id: projectId },
    })
  }

  return router.replace({
    name: permissions.PROJECTS.PROJECT.PERMISSION,
    params: { id: projectId },
  })
}
